import { getMetrics } from './metrics';

export const ErrorLocation = {
  WsMessageHandler: 'ws_message_handler',
  WsHandlerWedged: 'ws_handler_wedged',
  WsMessageParse: 'ws_message_parse',
  WsManualReconnect: 'ws_manual_reconnect',
  WsSendFailed: 'ws_send_failed',
  WsReconnectFailed: 'ws_reconnect_failed',
  WsQueuedMessageReplay: 'ws_queued_message_replay',
  WsConnectError: 'ws_connect_error',
  WsProtocolError: 'ws_protocol_error',
  GameSnapshotTimerStarted: 'game_snapshot_timer_started',
  GameSnapshotStateRestored: 'game_snapshot_state_restored',
  GameSnapshotPlayerNotFound: 'game_snapshot_player_not_found',
  GameSnapshotGraceTimeout: 'game_snapshot_grace_timeout',
  GameSnapshotWordSubmitInvalidId: 'game_snapshot_word_submit_invalid_id',
  GameSnapshotWordSubmitFailed: 'game_snapshot_word_submit_failed',
  GameSnapshotSubmissionRejectedNoReason: 'game_snapshot_submission_rejected_no_reason',
  GameFlowUnknownStatus: 'game_flow_unknown_status',
  GameFlowUnknownEvent: 'game_flow_unknown_event',
  TimerExpiryCallback: 'timer_expiry_callback',
  ConnectionManualReconnect: 'connection_manual_reconnect',
  AppAutoConnectFailed: 'app_auto_connect_failed',
  PlayerStatusUnknownVariant: 'player_status_unknown_variant',
  MatchmakingBotStartTimeout: 'matchmaking_bot_start_timeout',
  LetterSelectionNoPlayers: 'letter_selection_no_players',
  LetterSelectionNoCurrentPlayer: 'letter_selection_no_current_player',
  LetterSelectionInvalidCurrentPlayer: 'letter_selection_invalid_current_player',
  AuthLoginUnexpected: 'auth_login_unexpected',
  AuthSignupUnexpected: 'auth_signup_unexpected',
  AuthForgotPasswordUnexpected: 'auth_forgot_password_unexpected',
  AuthResetPasswordUnexpected: 'auth_reset_password_unexpected',
  PasswordResetRequestUnexpected: 'password_reset_request_unexpected',
  PasswordResetConfirmUnexpected: 'password_reset_confirm_unexpected',
  AuthCheckSessionFailed: 'auth_check_session_failed',
  SettingsAccountEmailFetchFailed: 'settings_account_email_fetch_failed',
  TutorialStatePersist: 'tutorial_state_persist',
  VueRenderError: 'vue_render_error',
  WindowError: 'window_error',
  UnhandledRejection: 'unhandled_rejection',
  ResourceLoadError: 'resource_load_error',
  LongtaskObserverFailed: 'longtask_observer_failed',
  RouterTimingFailed: 'router_timing_failed',
  VisibilityHandlerFailed: 'visibility_handler_failed',
  HeartbeatFailed: 'heartbeat_failed',
} as const;

export type ErrorLocation = (typeof ErrorLocation)[keyof typeof ErrorLocation];

export function reportClientError(error: unknown, location: ErrorLocation): void {
  try {
    getMetrics().clientCodeErrors.add(1, { location });
  } catch (metricError) {
    console.error(`[${location}] Failed to record metric:`, metricError);
  }
  console.error(`[${location}]`, error);
}
